import { render, staticRenderFns } from "./xiaoyun.vue?vue&type=template&id=4eefe374&scoped=true&"
import script from "./xiaoyun.vue?vue&type=script&lang=js&"
export * from "./xiaoyun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eefe374",
  null
  
)

export default component.exports